// src/pages/reservas/components/ModalEntrega.jsx
import React, { useEffect, useRef, useState } from 'react';
import ReciboReserva from './ReciboReserva';
import {imprimirReciboReserva} from '../../../utils/impresionConsumo';
import { descargarReciboReserva, tieneReciboConsumo } from '../../../utils/reciboReserva';
import VistaEntrada from '../../entradas/VistaEntrada';
import { prepararArchivosEntradasReserva } from '../../../utils/compartirEntradasReserva';

export default function ModalEntrega({
  entrega,
  onClose,
  onEnviarWhatsapp,
  onDescargarZip,
  compartiendo = false,
}) {
  const capturas = useRef(null);
  const [preparacion, setPreparacion] = useState(null);
  const [intento, setIntento] = useState(0);
  const [progreso, setProgreso] = useState(0);
  const [errorRecibo, setErrorRecibo] = useState('');
  const [descargandoRecibo, setDescargandoRecibo] = useState(false);
  const [papel,setPapel]=useState(80);
  const compartirHabilitado = typeof onEnviarWhatsapp === 'function';
  useEffect(() => {
    if (!entrega?.items?.length) return undefined;
    const controller = new AbortController();
    setPreparacion(null);
    setProgreso(0);
    prepararArchivosEntradasReserva(entrega, capturas.current.querySelectorAll('.entrada-preview-capture'), { signal: controller.signal, onProgress: count => { if (!controller.signal.aborted) setProgreso(count); } })
      .then((files) => { if (!controller.signal.aborted) setPreparacion({ entrega, files }); })
      .catch((error) => { if (!controller.signal.aborted) setPreparacion({ entrega, error: error.message }); });
    return () => controller.abort();
  }, [entrega, compartirHabilitado, intento]);
  const lista = preparacion?.entrega === entrega ? preparacion : null;
  if (!entrega) return null;

  return (
    <div className="modal-overlay wizard-backdrop" onMouseDown={onClose}>
      <div className="modal wizard-modal" onMouseDown={(e) => e.stopPropagation()}>
        <div className="wizard-header">
          <h3>{entrega.items.length?'Entrega de entradas':'Resumen de reserva'}</h3>
          <button className="wizard-close" disabled={compartiendo} onClick={onClose} aria-label="Cerrar">
            ✕
          </button>
        </div>

        <p className="wizard-question">{!entrega.reserva ? 'Entradas registradas' : entrega.reserva?.estado === 'reservada' ? 'Entradas adicionales confirmadas ✅' : 'Reserva prepagada confirmada ✅'}</p>

        <div className="wizard-summary">
          <div><b>Cliente:</b> {entrega.comprador}</div>
          {entrega.zonaTitulo&&<div><b>Zona:</b> {entrega.zonaTitulo}</div>}
          {entrega.paqueteNombre&&<div><b>Paquete:</b> {entrega.paqueteNombre}</div>}
          <div><b>Entradas disponibles para entregar:</b> {entrega.items.length}</div>
        </div>

        <ReciboReserva entrega={entrega}/>
        {errorRecibo && <div className="wizard-error" role="alert">{errorRecibo}</div>}
        {((entrega.permiteDetalleUso&&entrega.usadas>0)||entrega.excluidas>0)&&<p className="wizard-info">{entrega.permiteDetalleUso?`Se excluyen ${entrega.usadas||0} usadas y `:'Se excluyen '}{entrega.excluidas||0} anuladas/bloqueadas de la entrega.</p>}


        {lista?.error && <div className="wizard-error" role="alert">
          No se pudieron preparar las imágenes: {lista.error}
          <button type="button" className="btn-secondary" onClick={() => setIntento((n) => n + 1)}>Reintentar preparación</button>
        </div>}
        <div className="modal-actions">
          {tieneReciboConsumo(entrega)&&entrega.recibo.qr&&<div className="reserva-recibo-impresion"><label>Papel<select aria-label="Ancho de papel térmico" value={papel} onChange={e=>setPapel(Number(e.target.value))}><option value={80}>80 mm</option><option value={58}>58 mm</option></select></label><button type="button" className="btn-secondary" onClick={()=>{setErrorRecibo('');try{imprimirReciboReserva(entrega,papel);}catch(e){setErrorRecibo(e.message);}}}>Imprimir consumo</button></div>}
          {tieneReciboConsumo(entrega) && <button type="button" className="btn-secondary" disabled={descargandoRecibo} onClick={async () => { setDescargandoRecibo(true); setErrorRecibo(''); try { await descargarReciboReserva(entrega); } catch(e) { setErrorRecibo(e.message); } finally { setDescargandoRecibo(false); } }}>{descargandoRecibo ? 'Preparando recibo…' : 'Descargar recibo'}</button>}
          {!entrega.items.length?<button type="button" className="btn-primary" onClick={onClose}>Cerrar</button>:<><button type="button" className="btn-secondary" disabled={compartiendo || !compartirHabilitado || !lista?.files?.length} onClick={() => onEnviarWhatsapp(lista.files)}>
            {compartiendo ? 'Compartiendo…' : !lista && entrega.items.length ? `Preparando ${progreso}/${entrega.items.length}…` : 'Enviar por WhatsApp'}
          </button>
          <button type="button" className="btn-primary" disabled={compartiendo || !lista?.files?.length} onClick={() => onDescargarZip?.(lista.files)}>
            Descargar ZIP
          </button></>}
        </div>

        {/* Previews ocultos para capturar ZIP */}
        <div
          ref={capturas}
          className="reserva-entrega-capturas"
        >
          {entrega.items.map((it) => (
            <div key={it.id} className="entrada-preview-capture">
              <VistaEntrada id={it.id} evento={entrega.evento} arteEntrada={entrega.evento?.arteEntrada || entrega.evento?.arteEntrada} layoutEntrada={entrega.evento?.layoutEntrada} width={360} />
              <div className="reserva-ticket-ubicacion">{entrega.zonaTitulo}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
